"use client";

import { previewFeedbackTarget, useAccountStore } from "@repo/lib";
import { DataFeedback } from "@repo/ui/data";
import { useI18n } from "@repo/ui/providers";

/**
 * Feedback on an active Elite preview, shown to the people who can use it.
 * Lands in api-forge `/reports` as target `preview:<slug>`; api-forge files a
 * `preview_feedback` inbox item that the agents work.
 */
export function PreviewFeedback({
  appName,
  slug,
  className,
}: {
  appName: string;
  slug: string;
  className?: string;
}) {
  const { t } = useI18n();
  const hasAccess = useAccountStore((s) => s.perks.previewReleaseAccess);
  if (!hasAccess) return null;
  return (
    <DataFeedback
      appName={appName}
      targetId={previewFeedbackTarget(slug)}
      labels={{
        question: t("www.previews.feedback.question"),
        yes: t("www.previews.feedback.yes"),
        no: t("www.previews.feedback.no"),
        addNote: t("www.previews.feedback.addNote"),
        notePlaceholder: t("www.previews.feedback.notePlaceholder"),
      }}
      noteOnUp
      className={className}
    />
  );
}
